import { render, staticRenderFns } from "./newQuestionDia.vue?vue&type=template&id=59bc16d8&scoped=true"
import script from "./newQuestionDia.vue?vue&type=script&lang=js"
export * from "./newQuestionDia.vue?vue&type=script&lang=js"
import style0 from "./newQuestionDia.vue?vue&type=style&index=0&id=59bc16d8&prod&lang=scss&scoped=true"
import style1 from "./newQuestionDia.vue?vue&type=style&index=1&id=59bc16d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bc16d8",
  null
  
)

export default component.exports